import React, { createRef, useEffect, useMemo, useRef, useState } from "react";
import { useSearch } from "../../../Contexts/SearchContext";
import "./LevelTwoFilterDrawerAccordion.scss";
import { getActiveFiltersWithBefore, setFilterState, dispatchActiveFilters, getActiveFilters } from "../../../../helpers";

const LevelTwoFilterDrawerAccordion = ({
  data,
  index,
  setFilteredLabels
}) => {
  const { state, dispatch } = useSearch();
  const { filteredResults, componentElement, completeSearchResultSet } = state;
  const $levelTwoElement = createRef();
  const $levelTwoCheckbox = useRef(null);
  const [$isChecked, setIsChecked] = useState(false);

  const getTotalFilterCount = () => {

    if (!data || !data.filters) return 0;

    return data.filters.reduce((totalCount, filter) => {
      let count = 0;

      if (filteredResults && filteredResults.length > 0) {
        count = filteredResults.filter((result) => {
          const tagValue = result.Fields.formattedPageTags.Value;
          return (tagValue.indexOf(`"tagId":"${filter.tagPath}"`) >= 0 || tagValue.indexOf(`'tagId':'${filter.tagPath}'`) >= 0);
        }).length
      }

      return totalCount + count;
    }, 0);
  };

  const trackFilterCheckForDataLayer = (checkbox) => {
    let filterTitle = checkbox.nextSibling?.textContent;
    if (checkbox.classList.contains("cmp-accordion__header-input")) filterTitle += " (select all)";
    let filterCategory = checkbox
      ?.closest(".cmp-accordion__level-two-item")
      ?.querySelector(".cmp-accordion__title")?.textContent;
    window.adobeDataLayer?.push({
      event: window.adobeDataLayerEvents?.component.searchFilterApplied,
      linkDetails: {
        clickName: 'Search Refinement Actions',
        clickType: `Filter Checkbox ${filterCategory.toLowerCase()}`,
        clickLocation: 'Product Finder Filter Rail',
        filter: {
          category: `filter by ${filterCategory}`,
          values: filterTitle.toLowerCase()
        }
      }
    });
  };

  const totalCount = useMemo(() => getTotalFilterCount(), [data.filters, filteredResults]);

  const updateFilters = (event) => {

    let checkbox = event.target;

    if (checkbox.checked) {
      trackFilterCheckForDataLayer(checkbox);
    }
    
    //or logic for tier-1
    let localCheckedCategoryFilters = getActiveFilters(componentElement);
    let localCheckedProductsAndServiceFilters = getActiveFiltersWithBefore();
    //added
    if (!localCheckedCategoryFilters.length & !localCheckedProductsAndServiceFilters.length) {
      dispatch(dispatchActiveFilters(completeSearchResultSet));
    } else if (localCheckedCategoryFilters.length > 0 && !localCheckedProductsAndServiceFilters.length) {
      dispatch({
        type: "UPDATE_SELECTED_FILTERS",
        payload: getActiveFilters(componentElement),
      });
    }else {
      dispatch(dispatchActiveFilters(completeSearchResultSet));
    }
    
    // dispatch(dispatchActiveFilters(completeSearchResultSet));

    setFilterState(checkbox.value, componentElement, checkbox.checked);
   }

  if (data) {

    return <>
      <div
        className={`cmp-accordion__level-two-item`}
        ref={$levelTwoElement}
      >
        {data.filters && data.filters.length > 0 && (
          <div className={"cmp-accordion__header"} >
            <div className={"cmp-accordion__header-wrapper"}>
              <input
                type="checkbox"
                className={`cmp-accordion__header-input ${!totalCount ? "checkbox-disabled" : ""} products_services_filters`}
                aria-label={`Select all ${data.label} filters.`}
                onChange={(e) => {
                  if (totalCount) {
                    updateFilters(e);
                    setIsChecked(e.target.checked);
                  }
                }}
                disabled={!totalCount}
                checked={$isChecked}
                ref={$levelTwoCheckbox}
                data-heading-filter-title={data.label.toLowerCase()}
                value={data.filters[0].tagPath.split("/")[0]}
              />
              <div className="cmp-accordion__dropdown-heading">
                <div className={`cmp-accordion__title ${!totalCount ? "text-disabled" : ""}`}>{data.label}</div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  } else {
    return null;
  }
};

export default LevelTwoFilterDrawerAccordion;